import { IMicrositeRecipient } from "./microsite-recipient";

export interface IMicrositeRecipientForCoach extends IMicrositeRecipient {
}